<template>
    <div v-bind:class="{show : dialogueVisible == true, displayblock : dialogueVisible == true}" class="modal sustainable-component update-user-department" tabindex="-1" v-bind:id="'customModal' + getId()" role="dialog">
        <div class="modal-dialog" v-bind:class="size" role="document">
            <div class="modal-content">
                <div class="modal-header bg-primary">
                    Uppdatera
                </div>

                <div class="modal-body pb-0">
                    <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
                        {{snackbarMessage}}
                    </v-snackbar>
                    <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
                        {{errorMessage}}
                    </v-snackbar>
                    <common-spinner v-bind:loading="loading > 0"></common-spinner>
                    <div class="container-fluid p-0">
                        <div class="row">
                            <v-form v-model="valid" ref="form">
                                <div class="container-fluid p-0">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="container-fluid p-0">
                                                <div class="row">
                                                    <div class="col">
                                                        <v-text-field bg-color="white"
                                                                      :rules="[rules.required]"
                                                                      name="Username"
                                                                      id="Username"
                                                                      type="text"
                                                                      label="Användarnamn"
                                                                      variant="outlined"
                                                                      v-model="user.Username"
                                                                      focused="true" disabled></v-text-field>
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col">
                                                        <v-text-field bg-color="white"
                                                                      :rules="[rules.required]"
                                                                      name="Email"
                                                                      id="Email"
                                                                      type="text"
                                                                      label="E-post"
                                                                      variant="outlined"
                                                                      v-model="user.Email"
                                                                      focused="true"></v-text-field>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col">

                                                        <v-select name="Department" v-model="user.DepartmentId" id="department" item-title="DepartmentName" item-value="DepartmentId" :items="departments" label="Avdelning">

                                                        </v-select>

                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <v-select name="Club" v-model="user.ClubId" item-title="ClubName" item-value="ClubId" :items="getClubs()" label="Klubb">

                                                        </v-select>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <v-select name="WorkSpace" v-model="user.WorkspaceId" item-title="WorkspaceName" item-value="WorkspaceId" :items="getWorkspaces()" label="Arbetsplats">

                                                        </v-select>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <v-select :rules="[rules.required]" name="PermissionLevel" item-title="name" item-value="val" v-model="user.PermissionLevel" :items="permissionLevels" label="Behörighet">

                                                        </v-select>
                                                    </div>
                                                </div>
                                                <div class="row" style="visibility:hidden">
                                                    <div class="col">
                                                        <v-text-field bg-color="white"
                                                                      name=""
                                                                      id=""
                                                                      type="text"
                                                                      label="Företag"
                                                                      variant="outlined"
                                                                      v-model="user.VirtualCompany"
                                                                      focused="true"></v-text-field>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </v-form>

                        </div>
                    </div>
                </div>
                <div class="modal-footer pt-2 pb-1">
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="close">
                        Stäng
                    </v-btn>
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="save">
                        Spara
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { getCurrentInstance } from 'vue'
    import ValidationService from "../../../Services/ValidationService";
    import AdminService from "../../../Services/AdminService";
    import { ref } from 'vue'
    const form = ref(null);

    export default {
        emits: ['updated'],
        name: 'update-user-department',
        props: {
            clubid: String,
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            close() {
                this.reset();
                this.dialogueVisible = false;
                this.thisModal.hide();
            },
            async open(user) {
                this.user = user;
                this.dialogueVisible = true;
                this.thisModal.show();
            },
            async loadDepartments() {
                var departments = [{ DepartmentName: 'Ingen vald', DepartmentId: null }, ...await AdminService.getDepartments()];
                this.departments = departments;
            },
            async loadClubs(departmentId) {
                var clubs = [{ ClubName: 'Ingen vald', ClubId: null }, ...await AdminService.getClubsFromDepartment(departmentId)];
                this.clubs = clubs;
            },
            async loadWorkspaces(clubId) {
                var workspaces = [{ WorkspaceName: 'Ingen vald', WorkspaceId: null }, ...await AdminService.getWorkspacesFromClub(clubId)];
                this.workspaces = workspaces;
            },
            async save() {
                var result = await this.form.validate()
                if (result.valid != true)
                    return;
                try {
                    await AdminService.updateUser(this.user);
                    this.reset();
                    this.dialogueVisible = false;
                    this.thisModal.hide();
                    this.$emit("updated");

                } catch (e) {
                    this.displayErrorSnackBar("Det gick inte att uppdatera användaren")
                }
            },

            reset() {
                //this.user = null;
            },
            getClubs() {
                return this.clubs;
            },
            getWorkspaces() {
                return this.workspaces;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            }
        },
        data() {
            return {
                rules: ValidationService.rules(),
                dialogueVisible: false,
                thisModal: {},
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
                loading: 0,
                user: {
                    DepartmentId: 0,
                    ClubId: 0,
                    WorkspaceId: 0,
                    Username: '',
                    Email: '',
                    Company:''
                },
                workspaces: [],
                clubs: [],
                departments: [],
                permissionLevels: [{ name: "Superadmin", val: 10 }, { name: "Avdelningsadministratör", val: 15 }, { name: "Administratör", val: 20 }, { name: "Användare", val: 30 }, { name: "Läsare", val: 40 }]
            };
        },
        watch: {
            'user.DepartmentId': function (newVal) {
                if (newVal != null) {
                    this.loadClubs(newVal);
                }
                else {
                    this.clubs = [];
                }
            },
            'user.ClubId': function (newVal) {
                if (newVal != null) {
                    this.loadWorkspaces(newVal)
                }
                else {
                    this.workspaces = [];
                }
            },
        },
        mounted() {
            this.loadDepartments();
            //this.loadWorkspaces();
            //this.loadClubs();

            this.$el.remove();
            document.body.appendChild(this.$el);

            // eslint-disable-next-line
            this.thisModal = new bootstrap.Modal(document.getElementById('customModal' + this.getId()), {});

        },
        // eslint-disable-next-line
        setup(props, { emit }) {
            return { form }
        }
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .modal-content {
        border-radius: unset;
    }

    .modal-footer {
        border-top-color: transparent;
    }

    .modal-header {
        border-top-left-radius: unset;
        border-top-right-radius: unset;
    }
</style>
